// extracted by mini-css-extract-plugin
module.exports = {"text":"FeedPost__text__9jKWr"};